import { AuditScreen } from '../features/console';

export function AuditLogPage() {
  return <AuditScreen />;
}
